import {Stack, Typography} from '@mui/material';

import {EmpionButton} from '../../../../../components/EmpionButton/EmpionButton';
import EmpionDialog from '../../../../../components/EmpionDialog/EmpionDialog';

export interface Props {
  open: boolean;
  title: string;
  content: string;
  onClose: () => void;
  onConfirm: () => void;
  cancelLabel: string;
  confirmLabel: string;
}

export const DeleteProfileItemDialog = ({
  open,
  title,
  content,
  onClose,
  onConfirm,
  cancelLabel,
  confirmLabel,
}: Props) => {
  return (
    <EmpionDialog open={open} onClose={onClose} title={title}>
      <Typography>{content}</Typography>
      <Stack direction='row' spacing={2} sx={{mt: 2}}>
        <EmpionButton onClick={onClose} color='primary'>
          {cancelLabel}
        </EmpionButton>
        <EmpionButton onClick={onConfirm} color='error'>
          {confirmLabel}
        </EmpionButton>
      </Stack>
    </EmpionDialog>
  );
};
